import React from "react";
import GenericSvg from "../coloredSvgs/GenericSvg";
import { svgs } from "../coloredSvgs/svgs";

const ExitModal = ({ init, color }) =>
(<div style={{ position: "absolute", top: "8px", left: "8px", cursor: "pointer" }} onClick={() => init(null)}>
    <GenericSvg fill={color} size={"27px"} svg={svgs.cancel} viewBox={"0 0 512 512"} />
</div>);
export default ExitModal;